import { render, staticRenderFns } from "./Documentacion.vue?vue&type=template&id=3f7daa20&"
import script from "./Documentacion.vue?vue&type=script&lang=js&"
export * from "./Documentacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports